import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "@/index.css";
import App from "@/App";
import { captureClickIdsAndUTM, getVisitorId, getSessionId } from "@/lib/tracking";

// ATTRIBUTION IS CAPTURED BEFORE THE FIRST RENDER, NOT IN AN EFFECT.
//
// This used to live in App's useEffect. React runs child effects before parent
// effects, so a page component's own `view_content` fired BEFORE App had read
// the UTM parameters off the URL — and read them back out of empty storage.
//
// The result was measured on 2026-08-20: an arrival at
// /offer?utm_source=twitter&utm_content=magnet-bio-twitter wrote a
// `view_content` row with every utm_* column NULL, while the `email_signup`
// that followed carried them correctly. Every landing's arrival event was
// unattributed, and an opt-in rate whose denominator cannot name its surface
// tells you a magnet is working without ever telling you which link worked.
//
// Running it here, at module scope, means storage is populated before any
// component mounts. It is idempotent, so App's effect can stay as a safety net.
captureClickIdsAndUTM();
getVisitorId();
getSessionId();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
